import { useEffect, useRef } from "react";
import parse from "html-react-parser";

type HtmlStringFormCaptureProps = {
  html: string;
};

export default function DynamicEmbedForm({ html }: HtmlStringFormCaptureProps) {
  const ref = useRef<HTMLDivElement>(null);
  const el = parse(html, {
    replace: function (domNode) {
      if (domNode.type === "script") {
        return <></>;
      }
    },
  });

  useEffect(() => {
    if (
      !document.querySelector(
        'script[src="https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/gbr/FormLoader/FormLoader.bundle.js"]',
      )
    ) {
      const script = document.createElement("script");
      script.src =
        "https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/gbr/FormLoader/FormLoader.bundle.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return <div ref={ref}>{el}</div>;
}
